export default __webpack_public_path__ + "static/media/i_bus-low_rd_tagless.a6b1ad8a.svg";